<nz-input-group *ngIf="recordProperty !== undefined && field.AdditionalInformationParsed.AddButtonText != null
&& field.AdditionalInformationParsed.AddButtonText != undefined
&& field.AdditionalInformationParsed.AddButtonText !== ''
&& recordProperty?.ValueAsObject != null
&& recordProperty?.ValueAsObject != undefined
&& recordProperty?.ValueAsObject !== ''" class="ant-input-affix-wrapper-textarea-with-clear-btn"
  [nzAddOnAfter]="button">
  <textarea
  [class]="parentClass"
    [nzAutosize]="{ minRows: field.AdditionalInformationParsed.TextAreaRows === 0 ? 5 : field.AdditionalInformationParsed.TextAreaRows }"
    nz-input [name]="sectionTagName+'.' +field.FieldName" [ngModel]="recordProperty.ValueAsObject | jsonStr"
    [ngModelOptions]="{ updateOn: 'blur'}" [disabled]="true" [readOnly]="recordProperty.ReadOnly" [maxlength]="field.MaxLength"></textarea>
</nz-input-group>

<nz-input-group *ngIf="recordProperty !== undefined && !(field.AdditionalInformationParsed.AddButtonText != null
  && field.AdditionalInformationParsed.AddButtonText != undefined
  && field.AdditionalInformationParsed.AddButtonText !== ''
  && recordProperty?.ValueAsObject != null
  && recordProperty?.ValueAsObject != undefined
  && recordProperty?.ValueAsObject !== '')" class="ant-input-affix-wrapper-textarea-with-clear-btn">
  <textarea
  [class]="parentClass"
    [nzAutosize]="{ minRows: field.AdditionalInformationParsed.TextAreaRows === 0 ? 5 : field.AdditionalInformationParsed.TextAreaRows }"
    nz-input [name]="sectionTagName+'.' +field.FieldName" [(ngModel)]="recordProperty.ValueAsObject"
    [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="valueChanged()" [disabled]="recordProperty.ReadOnly" [readOnly]="recordProperty.ReadOnly"
    [maxlength]="field.MaxLength"></textarea>

</nz-input-group>

<ng-template #button>
  <button nz-button nzType="default" (click)="openChildDrawer()">
    {{field.AdditionalInformationParsed.AddButtonText}}
  </button>
</ng-template>


<nz-drawer nzWrapClassName="confirmation-drawer" nzWrapClassName="drawer-size-3x" [nzVisible]="showChildDrawer"
  [nzTitle]="'List of free items' | locale" [nzClosable]="true" [nzFooter]="childDrawerFooter"
  (nzOnClose)="showChildDrawer = false">
  <form nz-form>
    <nz-table [nzData]="childDrawerData" [nzShowPagination]="false" #childDrawerTable>
      <thead>
        <tr>
          <th nzWidth="25px" nzLeft></th>
          <th *ngFor="let col of childDrawerDataHead">
            {{ col | locale }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let template of childDrawerTable.data;let parentIndex=index;">
          <td nzWidth="25px" class="actions-cell" nzLeft>
            <a nz-popconfirm [nzPopconfirmTitle]="'Are you sure you want to delete this row?'| locale"
              nzPopconfirmPlacement="bottomLeft" (nzOnConfirm)="deleteRow(parentIndex)"><i nz-icon nzType="close"
                nzTheme="outline"></i></a>
          </td>
          <ng-container *ngFor="let col of childDrawerDataHead">
            <td *ngIf="col !== 'Qty' && col !== 'Artikle Nr.' && col !=='Max'">
              {{ template[col] }}
            </td>
            <td *ngIf="col == 'Max'">
              {{ template[col] }}
            </td>
            <td *ngIf="col == 'Qty'">
              <nz-input-number [(ngModel)]="template[col]" [nzMax]="template['Max']" [name]="col+'_'+parentIndex">
              </nz-input-number>
            </td>
            <td *ngIf="col == 'Artikle Nr.'">
              <nz-form-control>
                <nz-input-group
                  nzSearch
                  [nzAddOnAfter]="suffixIconButton"
                >
                  <input
                    [name]="col+'_'+parentIndex"
                    nz-input
                    [(ngModel)]="template[col]"
                    (input)="onType($event)"
                    [ngModelOptions]="{ updateOn: 'blur' }"
                    (ngModelChange)="validateSelection(template[col],template)"
                    [nzAutocomplete]="auto"
                  />
                </nz-input-group>
                <ng-template #suffixIconButton>
                  <nz-button-group>
                    <button
                      nz-button
                      nz-dropdown
                      [nzDropdownMenu]="options"
                      nzTrigger="click"
                      (nzVisibleChange)="triggerMenu($event)"
                    >
                      <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
                    </button>
                    <nz-dropdown-menu #options="nzDropdownMenu">
                      <ul nz-menu *ngIf="loadingDropDownMenu">
                        <li nz-menu-item>
                          <nz-spin nzSimple></nz-spin> {{ "Loading" | locale }}
                        </li>
                      </ul>
                      <ul nz-menu *ngIf="!loadingDropDownMenu && moduleInformation != null">
                        <li
                          nz-menu-item
                          (click)="openSearchDrawer(template)"
                          *ngIf="moduleInformation.AuthorisedForList"
                        >
                          <i class="fal fa-search"></i> {{ "Search" | locale }}
                        </li>
                        <li
                          nz-menu-item
                          (click)="openView(template[col])"
                          *ngIf="moduleInformation.AuthorisedForView"
                        >
                          <i class="fal fa-eye"></i> {{ "View" | locale }}
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </nz-button-group>
                </ng-template>
              </nz-form-control>
              <nz-autocomplete #auto [nzOverlayClassName]="'linked-field-overlay'">
                <nz-auto-option *ngFor="let option of options" [nzValue]="option.value">{{
                  option.label
                }}</nz-auto-option>
              </nz-autocomplete>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </nz-table>
  </form>
</nz-drawer>

<ng-template #childDrawerFooter>
  <nz-space>
    <nz-space-item>
      <button nz-button nzType="primary" (click)="applyChanges()">
        {{ "OK" | locale }}
      </button>
    </nz-space-item>
    <nz-space-item>
      <button nz-button (click)="showChildDrawer = false">
        {{ "Cancel" | locale }}
      </button>
    </nz-space-item>
  </nz-space>
</ng-template>
